import { ACTION_TYPES, MUTATION_TYPES } from './types';

//Services or Api
import followUpService from './../api';

export const actions = {
  async [ACTION_TYPES.RESET](context) {
    context.commit(MUTATION_TYPES.RESET);
  },

  async [ACTION_TYPES.GET_BASIC_FILTERS](context, params) {
    //Validate first is we need to get collections filters
    let hasFilters = false;
    if (
      context.getters.getCurrentFilters.selectedAcademicYear != null &&
      params.AcademicYearId ==
        context.getters.getCurrentFilters.selectedAcademicYear.id
    ) {
      hasFilters = true;
    }
    if (!hasFilters) {
      context.dispatch('$_app/setLoading', true, { root: true });
      const requests = [
        followUpService.getAcademicYears(),
        followUpService.getRegions(params),
      ];
      Promise.all(requests)
        .then((response) => {
          const [academicYears, regions] = response;

          context.commit(MUTATION_TYPES.SET_ACADEMIC_YEARS, academicYears);
          const defaultRegion = regions.find((r) => r.selected);

          context.commit(MUTATION_TYPES.SET_REGIONS, regions);
          if (defaultRegion) {
            const params = {
              AcademicYearId: this.model.selectedAcademicYear.id,
              RegionId: defaultRegion.id,
            };
            //Call Districts (posibility: GET Alls)
            followUpService.getDistricts(params).then((districts) => {
              context.commit(MUTATION_TYPES.SET_DISTRICTS, districts);
            });
          }
        })
        .finally(() =>
          context.dispatch('$_app/setLoading', false, { root: true })
        )
        .catch(() =>
          context.dispatch('$_app/setLoading', false, { root: true })
        );
    }
  },
  async [ACTION_TYPES.GET_REGIONS](context, params) {
    context.dispatch('$_app/setLoading', true, { root: true });
    await followUpService
      .getRegions(params)
      .then((regions) => {
        context.commit(MUTATION_TYPES.SET_REGIONS, regions);
      })
      .finally(() =>
        context.dispatch('$_app/setLoading', false, { root: true })
      )
      .catch(() => context.dispatch('$_app/setLoading', false, { root: true }));
  },
  async [ACTION_TYPES.GET_DISTRICTS](context, params) {
    context.dispatch('$_app/setLoading', true, { root: true });

    await followUpService
      .getDistricts(params)
      .then((districts) => {
        context.commit(MUTATION_TYPES.SET_DISTRICTS, districts);
      })
      .finally(() =>
        context.dispatch('$_app/setLoading', false, { root: true })
      )
      .catch(() => context.dispatch('$_app/setLoading', false, { root: true }));
  },
  async [ACTION_TYPES.GET_SCHOOLS](context, params) {
    await followUpService
      .getSchools(params)
      .then((schools) => {
        context.commit(MUTATION_TYPES.SET_SCHOOLS, schools);
      })
      .finally(() =>
        context.dispatch('$_app/setLoading', false, { root: true })
      )
      .catch(() => context.dispatch('$_app/setLoading', false, { root: true }));
  },
  async [ACTION_TYPES.GET_INTERVIEWS](context, params) {
    context.dispatch('$_app/setLoading', true, { root: true });
    //Set current state of filter
    context.commit(MUTATION_TYPES.SET_CURRENT_FILTERS, params);
    //Sent
    await followUpService
      .getInterviews(params)
      .then((response) => {
        context.commit(MUTATION_TYPES.SET_INTERVIEWS, response);
      })
      .finally(() =>
        context.dispatch('$_app/setLoading', false, { root: true })
      )
      .catch(() => context.dispatch('$_app/setLoading', false, { root: true }));
  },
};
